import { Box, Flex, Spacer, Text } from "@chakra-ui/react";
import { CrashType, riskFactorColors, Score } from "@keita/lanepatrol-sdk";
import { t } from "i18next";
import { tScoreType } from "../utils/score-utils";

const entryMaxWidth = 70;
const defaultColor = "#DDDDDD";
interface Props {
  score?: Score;
}
export const ViewScoreSmall: React.FC<Props> = ({ score }) => {
  return (
    <Flex alignItems="center">
      <Flex direction="row" mr={4}>
        <Flex
          direction="column"
          maxWidth={entryMaxWidth}
          fontSize="xs"
          textAlign="center"
          alignItems="center"
        >
          <Text>{t("coding:global")}</Text>
          <Box
            mt={2}
            bg={
              score ? riskFactorColors[score.global.riskFactor] : defaultColor
            }
            borderRadius={4}
            width={12}
            flexShrink={0}
            fontSize="sm"
            textAlign="center"
          >
            {score ? score.global.value.toFixed(2) : "-"}
          </Box>
        </Flex>
      </Flex>
      <Box>
        {Object.values(CrashType).map((crashType, index) => {
          return (
            <Flex alignItems="center" key={index} mb={1}>
              <Box
                bg={
                  score
                    ? riskFactorColors[score[crashType].riskFactor]
                    : defaultColor
                }
                borderRadius={4}
                width={12}
                flexShrink={0}
                fontSize="sm"
                textAlign="center"
              >
                {score ? score[crashType].value.toFixed(2) : "-"}
              </Box>
              <Text pl={2} fontSize="xs" maxWidth={180}>
                {tScoreType(crashType)}
              </Text>
              <Spacer />
            </Flex>
          );
        })}
      </Box>
    </Flex>
  );
};
